import toast from 'react-hot-toast';
export const handleError = (error, message = null) => {
    console.error(error);
    const errorMessage = error.message ? error.message : JSON.stringify(error)
    toast.error(message ? message : errorMessage);
}
